import React from 'react'
import IphoneThreeCanvas from '../../component/iphoneComponent/iphoneThreeCanvas'
import './landingPage.css';

const HomePage = () => {
    return (
        <div className='homepageContainer'>
            <div className='homepageLeftContainer'>
                <div className='homepageTitle'>
                    Inroducing <label style={{color:'var(--logo-color)'}}>New</label> Users to <br/> Mobile World
                </div>
                <div className='homepageSubheading'>
                    Move beyond user-facing configuration as a growth priority
                </div>
                <div className='contactUsButton'>
                    Get Started
                </div>
            </div>
            <div className='homepageRightContainer'>
                <IphoneThreeCanvas/>
            </div>
        </div>
    )
}

export default HomePage